<template>
  <div class="mod-config">
    <el-form :inline="true" :model="searchForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-select v-model="searchType" :placeholder="$t('paymentRecord.selectSearchCondition')" clearable style="width: 150px">
          <el-option :label="$t('common.all')" value="" />
          <el-option :label="$t('paymentRecord.date')" value="date" />
          <el-option :label="$t('paymentRecord.coach')" value="coach" />
          <el-option :label="$t('paymentRecord.customer')" value="customer" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="searchType==='date'">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          :range-separator="$t('common.to')"
          :start-placeholder="$t('paymentRecord.startDate')"
          :end-placeholder="$t('paymentRecord.endDate')"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="searchType==='coach'">
        <el-select v-model="searchForm.coachId" :placeholder="$t('paymentRecord.selectCoach')" clearable filterable style="width: 180px">
          <el-option v-for="coach in coaches" :key="coach.id" :label="coach.jiaolianxingming" :value="coach.id" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="searchType==='customer'">
        <el-input v-model="searchForm.customerName" :placeholder="$t('paymentRecord.customerName')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('common.search') }}</el-button>
        <el-button @click="resetForm()">{{ $t('common.reset') }}</el-button>
        <el-button type="primary" icon="el-icon-download" @click="exportCsv">{{ $t('paymentRecord.exportCsv') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      style="width: 100%;">
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        width="80"
        :label="$t('table.id')">
      </el-table-column>
      <el-table-column
        prop="customerName"
        header-align="center"
        align="center"
        :label="$t('paymentRecord.customerName')">
      </el-table-column>
      <el-table-column
        prop="customerPhone"
        header-align="center"
        align="center"
        :label="$t('paymentRecord.customerPhone')">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        :label="$t('paymentRecord.customerType')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.customerType === 1" type="info">{{ $t('paymentRecord.casualCustomer') }}</el-tag>
          <el-tag v-else-if="scope.row.customerType === 2" type="success">{{ $t('paymentRecord.member') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="memberAccount"
        header-align="center"
        align="center"
        :label="$t('paymentRecord.memberAccount')">
        <template slot-scope="scope">
          {{ scope.row.memberAccount ? scope.row.memberAccount : '—' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="projectName"
        header-align="center"
        align="center"
        :label="$t('paymentRecord.projectName')">
        <template slot-scope="scope">
          {{ scope.row.projectName ? scope.row.projectName : '—' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="coachName"
        header-align="center"
        align="center"
        :label="$t('paymentRecord.coachName')">
        <template slot-scope="scope">
          {{ scope.row.coachName ? scope.row.coachName : '—' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="duration"
        header-align="center"
        align="center"
        width="80"
        :label="$t('paymentrecord.duration')">
      </el-table-column>
      <el-table-column
        prop="amount"
        header-align="center"
        align="center"
        width="100"
        :label="$t('paymentrecord.amount')">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        :label="$t('paymentrecord.servicePeriod')">
        <template slot-scope="scope">
          <div v-if="scope.row.startTime && scope.row.endTime">
            {{ formatDateTime(scope.row.startTime) }}<br> {{ $t('paymentrecord.to') }} <br>{{ formatDateTime(scope.row.endTime) }}
          </div>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        :label="$t('paymentrecord.paymentMethod')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.paymentMethod === 1" type="info">{{ $t('paymentrecord.cash') }}</el-tag>
          <el-tag v-else-if="scope.row.paymentMethod === 2" type="success">{{ $t('paymentrecord.memberBalance') }}</el-tag>
          <el-tag v-else-if="scope.row.paymentMethod === 3" type="warning">{{ $t('paymentrecord.wechat') }}</el-tag>
          <el-tag v-else-if="scope.row.paymentMethod === 4" type="danger">{{ $t('paymentrecord.alipay') }}</el-tag>
          <el-tag v-else type="info">{{ $t('paymentrecord.unknown') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="operatorName"
        header-align="center"
        align="center"
        :label="$t('paymentrecord.operator')">
      </el-table-column>
      <el-table-column
        prop="paymentTime"
        header-align="center"
        align="center"
        width="180"
        :label="$t('paymentrecord.paymentTime')">
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        :label="$t('paymentrecord.operation')">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row.id)">{{ $t('paymentrecord.detail') }}</el-button>
          <el-button type="text" size="small" @click="printReceipt(scope.row)">{{ $t('paymentrecord.print') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 详情弹窗 -->
    <el-dialog
      :title="$t('missingTranslations.paymentDetails')"
      :visible.sync="detailVisible"
      width="600px">
      <div v-if="detailData">
        <el-descriptions :column="2" border>
          <el-descriptions-item :label="$t('common.id')">{{ detailData.id }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.customerType')">
            <el-tag v-if="detailData.customerType === 1" type="info">{{ $t('missingTranslations.walkInCustomer') }}</el-tag>
            <el-tag v-else-if="detailData.customerType === 2" type="success">{{ $t('missingTranslations.member') }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.customerName')">{{ detailData.customerName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.customerPhone')">{{ detailData.customerPhone }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.memberAccount')" v-if="detailData.customerType === 2">{{ detailData.memberAccount || '—' }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.memberId')" v-if="detailData.customerType === 2">{{ detailData.memberId || '—' }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.projectName')">{{ detailData.projectName || '—' }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.projectId')">{{ detailData.projectId || '—' }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.coachName')">{{ detailData.coachName || '—' }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.coachId')">{{ detailData.coachId || '—' }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.serviceDuration')">{{ detailData.duration }} {{ $t('missingTranslations.minutes') }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.paymentAmount')">{{ detailData.amount }} {{ $t('common.yuan') }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.startTime')">{{ formatDateTime(detailData.startTime) || '—' }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.endTime')">{{ formatDateTime(detailData.endTime) || '—' }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.paymentStatus')">
            <el-tag v-if="detailData.paymentStatus === 1" type="success">{{ $t('missingTranslations.paid') }}</el-tag>
            <el-tag v-else type="danger">{{ $t('missingTranslations.unpaid') }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.paymentMethod')">
            <el-tag v-if="detailData.paymentMethod === 1" type="info">{{ $t('missingTranslations.cash') }}</el-tag>
            <el-tag v-else-if="detailData.paymentMethod === 2" type="success">{{ $t('missingTranslations.memberBalance') }}</el-tag>
            <el-tag v-else-if="detailData.paymentMethod === 3" type="warning">{{ $t('missingTranslations.wechat') }}</el-tag>
            <el-tag v-else-if="detailData.paymentMethod === 4" type="danger">{{ $t('missingTranslations.alipay') }}</el-tag>
            <el-tag v-else type="info">{{ $t('missingTranslations.unknown') }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.operator')">{{ detailData.operatorName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.operatorId')">{{ detailData.operatorId }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.paymentTime')">{{ detailData.paymentTime }}</el-descriptions-item>
          <el-descriptions-item :label="$t('common.createTime')">{{ detailData.createTime }}</el-descriptions-item>
          <el-descriptions-item :label="$t('missingTranslations.remark')" :span="2">{{ detailData.remark || $t('missingTranslations.none') }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <receipt-action 
          v-if="detailData" 
          :data="detailData" 
          type="payment">
        </receipt-action>
        <el-button @click="detailVisible = false">{{ $t('common.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ReceiptAction from '@/components/common/ReceiptAction'
import printService from '@/utils/printService'

export default {
  components: {
    ReceiptAction
  },
  data () {
    return {
      searchForm: {
        customerName: '',
        coachId: ''
      },
      dateRange: [],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      detailVisible: false,
      detailData: null,
      coaches: [],
      searchType: ''
    }
  },
  created () {
    this.getCoaches()
    this.getDataList()
  },
  methods: {
    // 获取教练列表
    getCoaches () {
      this.$http({
        url: '/jiaolian/list',
        method: 'get',
        params: { page: 1, limit: 1000 }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.coaches = data.data.list || []
        }
      })
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      
      // 构建查询参数
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
      }
      // 单一条件：日期/技师/客户
      if (this.searchType === 'coach' && this.searchForm.coachId) {
        params.coachId = this.searchForm.coachId
      } else if (this.searchType === 'customer' && this.searchForm.customerName) {
        params.customerName = this.searchForm.customerName
      } else if (this.searchType === 'date' && this.dateRange && this.dateRange.length === 2) {
        // 按付款时间筛选
        params.payment_time_start = this.dateRange[0]
        params.payment_time_end = this.dateRange[1]
      }
      
      this.$http({
        url: '/paymentrecord/page',
        method: 'get',
        params: params
      }).then(({data}) => {
        console.log("获取到的数据:", data);
        if (data && data.code === 0) {
          this.dataList = data.data.list || []
          this.totalPage = data.data.total || 0
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg || '获取数据失败')
        }
        this.dataListLoading = false
      }).catch(err => {
        console.error('获取数据出错:', err);
        this.dataList = []
        this.totalPage = 0
        this.dataListLoading = false
        this.$message.error('获取数据出错，请检查网络连接或联系管理员')
      })
    },
    // 导出CSV
    exportCsv () {
      if (!this.dataList || this.dataList.length === 0) {
        this.$message.info('暂无可导出的数据')
        return
      }
      const headers = [
        'ID','客户类型','客户姓名','客户电话','会员账号','项目名称','教练姓名','时长(分钟)','金额(元)','开始时间','结束时间','付款方式','操作员','付款时间'
      ]
      const rows = this.dataList.map(it => [
        it.id,
        it.customerType === 1 ? '散客' : it.customerType === 2 ? '会员' : '—',
        it.customerName || '',
        it.customerPhone || '',
        it.memberAccount || '',
        it.projectName || '',
        it.coachName || '',
        it.duration || '',
        it.amount || '',
        this.formatDateTime(it.startTime) || '',
        this.formatDateTime(it.endTime) || '',
        (it.paymentMethod===1?'现金':it.paymentMethod===2?'会员余额':it.paymentMethod===3?'微信':it.paymentMethod===4?'支付宝':'未知'),
        it.operatorName || '',
        it.paymentTime || ''
      ])
      const csv = [headers].concat(rows).map(r => r.map(v => `"${(v||'').toString().replace(/"/g,'""')}"`).join(',')).join('\n')
      const blob = new Blob(["\ufeff" + csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      const today = new Date()
      const y = today.getFullYear(), m = (today.getMonth()+1+'').padStart(2,'0'), d = (today.getDate()+'').padStart(2,'0')
      a.download = `支付记录_${y}${m}${d}.csv`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 重置查询表单
    resetForm () {
      this.searchForm = { customerName: '', coachId: '' }
      this.dateRange = []
      this.searchType = ''
      this.getDataList()
    },
    // 查看详情
    handleDetail (id) {
      this.detailVisible = true
      this.$http({
        url: `/paymentrecord/info/${id}`,
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.detailData = data.data
        } else {
          this.$message.error(data.msg || '获取详情失败')
        }
      }).catch(err => {
        console.error('获取详情出错:', err);
        this.$message.error('获取详情出错，请检查网络连接')
      })
    },
    printReceipt (row) {
      // 实现打印收据的逻辑
      console.log('打印收据', row)
    },
    // 格式化日期时间
    formatDateTime (dateTime) {
      if (!dateTime) return '';
      const date = new Date(dateTime);
      if (isNaN(date.getTime())) return '';
      
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    }
  }
}
</script>

<style scoped>
.mod-config {
  padding: 20px;
}
</style> 